import { useQuery } from "@apollo/client/react";
import { GetShippingRequestFilesDocument } from "./schema";
import { Query } from "./types";

export const usePaginatedShippingRequestFilesQuery = (
  baseOptions: useQuery.Options<Query>
) =>
  useQuery<Query>(GetShippingRequestFilesDocument, {
    ...baseOptions,
  });
